/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import TextField from "@mui/material/TextField";
import Button from "components/ButtonUse";
// Data

// Dashboard components

function ContactSetting() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <form
          style={{
            background: "white",
            padding: "10px",
            borderRadius: "10px",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          }}
          autoComplete="off"
          action=""
        >
          <div style={{ padding: "5px" }}>
            <div style={{ display: "flex", gap: "40px" }}>
              <TextField
                id="outlined-basic"
                sx={{ width: "20vw" }}
                label="Support Email"
                variant="outlined"
              />
              <TextField
                id="outlined-basic"
                sx={{ width: "20vw" }}
                label="Contact No"
                variant="outlined"
              />
              <TextField
                id="outlined-basic"
                sx={{ width: "20vw" }}
                label="Address"
                variant="outlined"
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "10vh",
              }}
            >
              <Button title={"submit"} />
            </div>
          </div>
        </form>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ContactSetting;
